<header>
  <app-banner [planData]="planData"></app-banner>
  <img
    class="mobile-background"
    src="/assets/img/benefit-mobile-background.svg"
    alt=""
  />

  <div class="benefit-container">
    <div class="d-flex">
      <button class="copec-lg-14 d-flex justify-content-center">
        <img
          src="/assets/icono-plans/{{ imgPlanUser }}"
          alt=""
          style="width: 20px; height: 20px"
        />
        {{ PlanUser }}
      </button>
      <button class="copec-rg-14 color-second-dark-blue" (click)="goToPlan()">
        Ver planes
      </button>
    </div>
  </div>
</header>
